module.exports = __webpack_public_path__ + "img/块面矩形-默认.a6fcf756.png";